import { defineStore } from "pinia";
import { ref } from "vue";

function createMessage(role, text) {
  return {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
    role,
    text,
    createdAt: new Date().toISOString(),
  };
}

function createWelcomeMessage() {
  return createMessage(
    "assistant",
    "Sou o Atmo Guia. Pergunte sobre regras, telas e fluxos do sistema."
  );
}

export const useAssistantStore = defineStore("assistant", () => {
  const isOpen = ref(false);
  const isLoading = ref(false);
  const loadingStatus = ref("");
  const messages = ref([createWelcomeMessage()]);

  function open() {
    isOpen.value = true;
  }

  function close() {
    isOpen.value = false;
  }

  function setLoading(value) {
    isLoading.value = !!value;
    if (!value) loadingStatus.value = "";
  }

  function setLoadingStatus(text) {
    loadingStatus.value = text || "";
  }

  function clearConversation() {
    messages.value = [createWelcomeMessage()];
  }

  function addUserMessage(text) {
    messages.value.push(createMessage("user", text));
  }

  function addAssistantMessage(text) {
    messages.value.push(createMessage("assistant", text));
  }

  function startStreamingAssistantMessage() {
    const message = createMessage("assistant", "");
    message.streaming = true;
    messages.value.push(message);
    return message.id;
  }

  function appendToMessage(id, text) {
    if (!text) return;
    const message = messages.value.find((m) => m.id === id);
    if (!message) return;
    message.text = (message.text || "") + text;
  }

  function replaceMessage(id, text) {
    const message = messages.value.find((m) => m.id === id);
    if (!message) return;
    message.text = String(text || "");
  }

  function finalizeStreamingMessage(id) {
    const message = messages.value.find((m) => m.id === id);
    if (!message) return;
    message.streaming = false;
  }

  function removeMessage(id) {
    const idx = messages.value.findIndex((m) => m.id === id);
    if (idx >= 0) messages.value.splice(idx, 1);
  }

  return {
    isOpen,
    isLoading,
    loadingStatus,
    messages,
    open,
    close,
    setLoading,
    setLoadingStatus,
    clearConversation,
    addUserMessage,
    addAssistantMessage,
    startStreamingAssistantMessage,
    appendToMessage,
    replaceMessage,
    finalizeStreamingMessage,
    removeMessage,
  };
});
